import loadable from "@loadable/component";

const Filter = loadable(() => import("./Filter.page"));

export default { component: Filter };
